export default __webpack_public_path__ + "static/media/0x1659ffb2d40dfb1671ac226a0d9dcc95a774521a.ea277e49.webp";